export default __webpack_public_path__ + "static/media/finance.c737b870.svg";